export default __webpack_public_path__ + "static/media/personalizedStudyPlan.87e701d0.svg";